import { motion } from "framer-motion";
import { PiggyBank, BadgePercent, FileCheck } from "lucide-react";
import { useLang } from "@/i18n";

const incentiveIcons = [BadgePercent, PiggyBank, FileCheck];

export default function Finance() {
  const { t } = useLang();
  const metrics = t.finance.metrics;
  const incentives = t.finance.incentives.map((inc, i) => ({ ...inc, icon: incentiveIcons[i] }));

  return (
    <section id="finanza" className="py-24 sm:py-32 border-b border-white/10" data-testid="finance-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="overline-tag" data-testid="finance-overline">
          {t.finance.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
          className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl" data-testid="finance-heading"
        >
          {t.finance.h2}
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 min-[420px]:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {metrics.map((m, i) => (
            <motion.div
              key={m.label}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
              className="min-w-0" data-testid={`metric-${i}`}
            >
              <p className="font-display font-bold text-4xl sm:text-5xl xl:text-6xl text-volt drop-shadow-[0_0_14px_rgba(0,255,136,0.35)]" data-testid={`metric-value-${i}`}>{m.value}</p>
              <p className="mt-3 text-sm text-steel max-w-[220px]" data-testid={`metric-label-${i}`}>{m.label}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-5">
          {incentives.map((inc, i) => (
            <motion.div
              key={inc.title}
              initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
              className="glass rounded-2xl p-7" data-testid={`incentive-card-${i}`}
            >
              <inc.icon className="text-volt" size={24} strokeWidth={1.5} />
              <h3 className="mt-4 font-display font-semibold text-lg">{inc.title}</h3>
              <p className="mt-2 text-sm text-steel leading-relaxed">{inc.text}</p>
            </motion.div>
          ))}
        </div>
        <p className="mt-8 text-xs text-steel/60" data-testid="finance-disclaimer">{t.finance.disclaimer}</p>
      </div>
    </section>
  );
}
